import type { ReactElement } from 'react';
import type {
  DashboardApiError,
  DashboardFilterReaderIslandRenderProps,
  DashboardModes,
  FullscreenWidgetProps,
  LoadedDashboard,
  OnWidgetDrilldown,
  OpenFullscreenWidget,
} from '@ardoq/dashboard';
import { Dashboard } from '@ardoq/dashboard';
import type { Maybe } from '@ardoq/common-helpers';
import type { Locale } from '@ardoq/locale';
import type { TrackFn } from 'tracking/track';
import type { CopyEntityURLButtonProps } from '@ardoq/snowflakes';
import type { HexColor } from '@ardoq/api-types';
import type { I18nLocale } from '@ardoq/i18n';
import { HtmlSlideCaptureSurface } from './HtmlSlideCaptureSurface';
import type { HtmlSlideCapture } from './slideCaptureSurface$';

export type DashboardSlideProps = {
  capture: HtmlSlideCapture;
  dashboardData: Maybe<LoadedDashboard>;
  mode: DashboardModes;
  userLocale: Locale;
  i18nLocale: I18nLocale;
  onWidgetDrilldown: OnWidgetDrilldown;
  isLoading: boolean;
  apiError: DashboardApiError | undefined;
  trackEvent: TrackFn;
  fullscreenWidgetProps: FullscreenWidgetProps;
  openFullscreenWidget: OpenFullscreenWidget;
  copyUrlButtonProps: CopyEntityURLButtonProps;
  isCaptureMode: boolean;
  dashboardColors: Record<string, HexColor>;
  dashboardFilterIslandProps: DashboardFilterReaderIslandRenderProps;
};

const DashboardSlide = ({
  capture,
  ...dashboardProps
}: DashboardSlideProps): ReactElement => (
  <HtmlSlideCaptureSurface capture={capture}>
    <Dashboard contextDashboardIsUsedIn="presentation" {...dashboardProps} />
  </HtmlSlideCaptureSurface>
);

export { DashboardSlide };
